export default __webpack_public_path__ + "2013 Investigating Polaron Transitions with Polar Molecules.pdf";